import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';
import { GaTrackingEventName } from '~shared/modules/ga-tracking/constants';
import { GATrackingEventPayload } from '~shared/modules/ga-tracking/models';

export class EditorialLinkNavigationClickApplicationEvent implements ApplicationEvent {
  type = ApplicationEventType.EditorialLinkNavigationClick;

  constructor(private label: string) {}

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.EditorialLinkNavigationClick,
      label: this.label,
    };
  }
}
